import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, LockKeyhole } from "lucide-react";
import { useAuth } from "../lib/auth";
import { errMsg } from "../lib/api";
import { Btn } from "../components/kit/Kit";
import { QuickLogin } from "../components/kit/QuickLogin";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [aviso] = useState(() => { const m = sessionStorage.getItem("logout_motivo"); sessionStorage.removeItem("logout_motivo"); return m; });
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to={user.role === "referenciador" ? "/portal" : "/"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
      nav("/");
    } catch (ex) {
      setErr(errMsg(ex, "No se pudo iniciar sesión"));
    } finally {
      setBusy(false);
    }
  };
  const inp = "mt-1.5 w-full rounded-xl border border-[#E2DDD5] bg-[#FAF8F5] px-4 py-3 text-sm outline-none transition-colors focus:border-[#E8643C] focus:bg-white";
  return (
    <div className="grid min-h-screen bg-[#F2F0EC] lg:grid-cols-2" data-testid="login-page">
      <div className="relative hidden flex-col justify-between overflow-hidden bg-[#111] p-14 text-white lg:flex">
        <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#E8643C]/20 blur-3xl" />
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E8643C]">Credit Platform</p>
        <div className="relative">
          <h1 className="font-serif-display text-5xl font-bold leading-tight">Decisiones de crédito<br />claras, paso a paso<span className="text-[#E8643C]">.</span></h1>
          <p className="mt-6 max-w-md text-zinc-400">Expediente, documentos, motor paramétrico y Credit Memo en un solo flujo para el equipo de riesgo de Trafalgar SFP.</p>
        </div>
        <p className="text-xs text-zinc-500">Trafalgar SFP, S.A. de C.V., S.F.P. · Uso interno</p>
      </div>
      <div className="flex flex-col items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-md rounded-3xl border border-[#E2DDD5] bg-white p-10 shadow-sm" data-testid="login-form">
          <img src="/trafalgar-logo-transparent.svg" alt="Trafalgar Credit Platform" className="h-14 w-auto" />
          <h2 className="font-serif-display mt-8 text-3xl font-bold">Iniciar sesión</h2>
          <p className="mt-2 text-sm text-[#5C5850]">Accede con tu cuenta asignada por el Director de Crédito.</p>
          <label className="mt-8 block text-xs font-semibold uppercase tracking-widest text-[#8C867A]">Correo
            <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inp} placeholder="nombre@trafalgar.mx" />
          </label>
          <label className="mt-5 block text-xs font-semibold uppercase tracking-widest text-[#8C867A]">Contraseña
            <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inp} />
          </label>
          {aviso && !err && <p className="mt-4 rounded-xl bg-amber-50 px-4 py-2.5 text-sm text-amber-800" data-testid="login-aviso-sesion">{aviso}</p>}
          {err && <p className="mt-4 rounded-xl bg-rose-50 px-4 py-2.5 text-sm text-rose-700" data-testid="login-error">{err}</p>}
          <Btn kind="accent" type="submit" disabled={busy} className="mt-8 w-full py-3" data-testid="login-submit-button">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <LockKeyhole size={16} />} Entrar
          </Btn>
        </form>
        <QuickLogin />
      </div>
    </div>
  );
}
